function cssHeaderHeight() {
  const height = document.querySelector("header .header_menu").clientHeight - 1;
  document.documentElement.style.setProperty(
    "--pg-header-height",
    height + "px"
  );

  // const header = document.querySelector("html header.main");
  const wrapper = document.querySelector("#wrapper");
  const offset =
    // Math.abs(
    //   parseInt(
    //     window.getComputedStyle(header).getPropertyValue("margin-bottom")
    //   )
    // ) +
    Math.abs(
      parseInt(window.getComputedStyle(wrapper).getPropertyValue("margin-top"))
    );
  document.documentElement.style.setProperty(
    "--pg-header-offset",
    offset + "px"
  );
}
cssHeaderHeight();
window.addEventListener("resize", cssHeaderHeight);
